const NAVBAR_PROFILE_BUTTON_CLASS_NAME = 'navbar-profile-button';
const DEFAULT_ICON_BUTTON_CLASS_NAME = 'default-icon-button';
const COMPACT_ICON_BUTTON_CLASS_NAME = 'compact-icon-button';
const GO_BACK_ICON_BUTTON_CLASS_NAME = 'go-back-icon-button';
export {
  NAVBAR_PROFILE_BUTTON_CLASS_NAME,
  DEFAULT_ICON_BUTTON_CLASS_NAME,
  COMPACT_ICON_BUTTON_CLASS_NAME,
  GO_BACK_ICON_BUTTON_CLASS_NAME,
};
